import { IKeyValue } from './prostate-cancer-calc-form.component';

export const tumorTypeList = ['ADENOCARCINOMA', 'NEOPLASIA', 'CARCINOMA', 'FIBROMA', 'FIBROMIOMA', 'SARCOMA', 'OTHER'];
export const gleasonList = ['≤6', '>6 - ≤7', '>7 - ≤8', '>8 - ≤9', '>9', 'NOTAVAILABLE'];
export const historicalGrade = ['I', 'II', 'III', 'IV', 'V', 'NOTAVAILABLE'];
export const stages = ['', 'IA', 'IB', 'IIA', 'IIB', 'IIC', 'IIIA', 'IIIB', 'IIIC', 'IVA', 'IVB'];
export const prostateCancerTNM: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'Tis',
    value: 'Tis'
  },
  {
    key: 'T0',
    value: 'T0'
  },
  {
    key: 'T1',
    value: 'T1'
  },
  {
    key: 'T2',
    value: 'T2'
  },
  {
    key: 'T3',
    value: 'T3'
  },
  {
    key: 'T4',
    value: 'T4'
  },
  {
    key: 'Tx',
    value: 'Tx'
  }
];
export const nodalInvolvementOptions: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'N0',
    value: 'N0'
  },
  {
    key: 'N1',
    value: 'N1'
  },
  {
    key: 'Nx',
    value: 'Nx'
  }
];
export const metastasesOptions: IKeyValue[] = [
  {
    key: '',
    value: ''
  },
  {
    key: 'M0',
    value: 'M0'
  },
  {
    key: 'M1',
    value: 'M1'
  },
  {
    key: 'Mx',
    value: 'Mx'
  }
];
export const psaAntigen = [
  '<10',
  '≥10 - <20',
  '≥20',
  'NOTAVAILABLE'
];
export const KI67 = [
  '',
  '>15%',
  '≤15%'
];
